import React from 'react';
import './ValueBenefits.css';
import logoIcon from '../../assets/logo icon.png';

const ValueBenefits = () => {
  return (
    <section className="value-benefits-section">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">What We Do</h2>
          <p className="section-subtitle">
            Discover why real estate tokenization{'\n'}offers unique advantages for investors
          </p>
        </div>
        
        {/* Value Benefits Graphic */}
        <div className="value-benefits-graphic">
          {/* Left side - Three blocks stacked vertically */}
          <div className="left-blocks">
            <div className="teal-block">High Quality Real Estate</div>
            <span className="plus-sign">+</span>
            <div className="teal-block">Experienced Managers</div>
            <span className="plus-sign">+</span>
            <div className="teal-block">Tokenized Assets</div>
          </div>
          
          {/* Equals sign */}
          <span className="equals-sign">=</span>
          
          {/* Right side - Real World Equity block */}
          <div className="rwe-block">
            <h3 className="rwe-title">Real World Equity</h3>
            <img src={logoIcon} alt="Logo" className="rwe-logo" />
          </div>
        </div>
        
        {/* Text blocks below the grid */}
        <div className="text-blocks-container">
          <div className="text-block">
            <p className="text-block-paragraph">
              Single-tenant, institutional assets delivering steady cash flow backed by long-term NN/NNN leases, US-wide
            </p>
          </div>
          
          <div className="text-block">
            <p className="text-block-paragraph">
              National brands on durable leases deliver rent with escalations and resilient performance on time, monthly
            </p>
          </div>
          
          <div className="text-block">
            <p className="text-block-paragraph">
              On-chain ownership provides records, wallet payouts, and approved transfers enabling optional liquidity
            </p>
          </div>
          
          <div className="text-block">
            <p className="text-block-paragraph">
              Quality real estate, national tenants & tokenized ownership combine to deliver transparent liquid income
            </p>
          </div>
        </div>
        
        {/* CTA Buttons */}
        <div className="cta-container">
          <a href="/tokenization" className="cta-button">Tokenization</a>
          <a href="/assets" className="cta-button">The Assets</a>
        </div>
      </div>
    </section>
  );
};

export default ValueBenefits; 